import { Directive, ElementRef, EventEmitter, HostListener, OnInit, Output, Renderer2 } from '@angular/core';

@Directive({
  selector: '[yatTabSelectable]'
})
export class TabSelectableDirective implements OnInit {
  constructor(private element: ElementRef, private renderer: Renderer2) {}

  @Output()
  tabSelect: EventEmitter<Event> = new EventEmitter();

  ngOnInit(): void {
    this.renderer.setAttribute(this.element.nativeElement, 'tabindex', '0');
    this.renderer.addClass(this.element.nativeElement, 'selectable');
  }

  @HostListener('click', ['$event'])
  click(event: MouseEvent): void {
    this.tabSelect.emit(event);
  }

  @HostListener('keypress', ['$event'])
  keypress(event: KeyboardEvent): void {
    if (event.code === 'Space' || event.code === 'Enter') {
      this.tabSelect.emit(event);
    }
  }
}
